module.exports = __webpack_public_path__ + "static/cfo-22aaa57332ba4cf88140471e2de98fae.png";